var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWarrantyStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9939 12.996C19.9939 17.9945 16.4949 20.4937 12.3362 21.9432C12.1184 22.017 11.8819 22.0135 11.6664 21.9332C7.4977 20.4937 3.99878 17.9945 3.99878 12.996V5.99815C3.99878 5.73301 4.1041 5.47874 4.29158 5.29126C4.47906 5.10378 4.73334 4.99846 4.99847 4.99846C6.99786 4.99846 9.49709 3.79883 11.2365 2.2793C11.4483 2.09835 11.7178 1.99893 11.9963 1.99893C12.2749 1.99893 12.5443 2.09835 12.7561 2.2793C14.5055 3.80882 16.9948 4.99846 18.9942 4.99846C19.2593 4.99846 19.5136 5.10378 19.701 5.29126C19.8885 5.47874 19.9939 5.73301 19.9939 5.99815V12.996Z",
    stroke: "#0B5ED7",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWarrantyStatus);
export default __webpack_public_path__ + "static/media/check_warranty_status.b379e5c5b7fa88c207c5d2fd83cd9d16.svg";
export { ForwardRef as ReactComponent };